module.exports = __webpack_public_path__ + "img/picture.030576d4.png";